import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { usageColumns } from "../../../../constants/lineListColumns";
import { CLIENTS, OPERATIONS } from "../../../../constants/value";
import { __getUsage } from "../../../../api/sim";

const COPY_KEYS = [
  "msisdn",
  "used",
  "remaining",
  "usage_status",
  "limit_value",
  "value_unit",
  "throttle_speed",
  "auto_renew",
  "period_type",
  "period_value",
  "renewal_day",
  "status",
];

const TmobilejUsageBatch = () => (
  <BatchDetail
    title="Usage"
    apiGet={__getUsage}
    client={CLIENTS.tmobilej}
    columnsFactory={usageColumns}
    copyKeys={COPY_KEYS}
    exportAction={OPERATIONS.usage}
    exportFilename={(batchId) => `tmobilej_usage_export-${batchId}.csv`}
    retryOperation={OPERATIONS.usage}
    showTerminate
    terminateOperation={OPERATIONS.usage}
    getRowPath={(row) => `/tmobilej/usage/${row.id}`}
  />
);

export default TmobilejUsageBatch;
